import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { DealerListItem } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'app',
    events: {
        'Init Page': props<{ isE2e: boolean }>(),

        'Load Dealer List': emptyProps(),
        'Load Dealer List Success': props<{ dealers: DealerListItem[] }>(),
        'Load Dealer List Failure': props<{ error: string }>(),
    },
});
